module.exports = __webpack_public_path__ + "static/media/giftsSent_75_100.ddcd57f0.png";